<template>
  <v-container>
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form ref="form" @submit.prevent="saveSettings">
      <v-col cols="12" md="12" sm="12">
        <v-col class="pa-5">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company Type</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Company Type"
                v-model="form.company_type"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company Name</p>
              </v-col>
              <v-text-field
                outlined
                dense
                lplaceholder="Enter Company Name"
                v-model="form.company_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Company Contact Number</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Company Contact Number"
                v-model="form.company_contact_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Email</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Email"
                v-model="form.company_email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Address</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Address"
                v-model="form.company_address"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">City</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter City"
                v-model="form.company_city"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">State</p>
              </v-col>
              <v-autocomplete
                v-model="form.company_state"
                :items="states"
                placeholder="Select State"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Country</p>
              </v-col>
              <v-autocomplete
                v-model="form.company_country"
                :items="countries"
                placeholder="Select Country"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Date Format</p>
              </v-col>
              <v-autocomplete
                placeholder="Select Date Format"
                v-model="form.date_formate"
                :items="dateFormats"
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Currency</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Currency"
                v-model="form.currency"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Currency Code</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Enter Currency Code"
                v-model="form.currency_code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Tax</p>
              </v-col>
              <v-autocomplete
                v-model="form.tax_type"
                :items="taxes"
                placeholder="Select TAX"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Attach Company Logo</p>
              </v-col>
              <v-file-input
                placeholder="Attach Company Logo "
                v-model="form.company_logo"
                :prepend-icon="false"
                dense
                outlined
              ></v-file-input>
              <ImageBox v-if="imageUrl" :imageUrl="imageUrl" />
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Time zone</p>
              </v-col>
              <v-text-field
                outlined
                dense
                placeholder="Time Zone"
                v-model="form.time_zone"
              ></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
              <v-switch
                v-model="form.force_2fa"
                label="Force Two-Factor Authentication for all users"
                color="primary"
                inset
              ></v-switch>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="9" xs="6"></v-col>
              <v-col cols="12" md="3" xs="6">
                <v-btn large color="#00B3FF" dark depressed block type="submit"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-col>
      </v-col>
    </v-form>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </v-container>
</template>

<script>
import { SettingsService } from "../../services/setting-service.js";
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import ImageBox from "@/components/shared/ImageBox";

export default {
  components: { Alert, Snackbars, ImageBox },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      imageUrl: "null",
      form: {
        company_type: "",
        company_name: "",
        company_contact_number: "",
        company_phone: "",
        company_email: "",
        company_logo: null,
        company_address: "",
        company_city: "",
        company_state: "",
        company_country: "",
        time_zone: "",
        currency: "",
        currency_code: "",
        date_formate: "",
        tax_type: "",
        force_2fa: false,
      },
      dateFormats: ["mm/dd/yy", "dd/mm/yy", "yy/mm/dd"],
      taxes: ["GST", "VAT"],
      countries: [],
      states: [],
    };
  },
  created() {
    this.getCompanySettings();
  },
  mounted() {
    this.getCountries();
  },

  watch: {
    "form.company_country": function(newCountry, oldCountry) {
      if (this.form.company_country !== null) {
        if (newCountry !== oldCountry) {
          this.getStates();
        }
      } else {
        this.form.company_state = "";
        this.states = [];
      }
    },
  },
  methods: {
    getCompanySettings() {
      this.loading = true;
      SettingsService.getCompanySettings()
        .then((response) => {
          const settings = response.data.data;
          settings.forEach((setting) => {
            if (Object.prototype.hasOwnProperty.call(this.form, setting.key)) {
              let value = setting.value;
              if (value === "true" || value === "false") {
                value = value === "true";
              }
              if (setting.key === "company_logo") {
                this.imageUrl = value || "null";
              } else {
                this.form[setting.key] = value;
              }
            }
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errors = checkError.errorFormatting(error.response.data);
        });
    },
    saveSettings() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const formData = new FormData();

        Object.entries(this.form)
          .filter(([, value]) => value !== "" && value !== null)
          .forEach(([key, value]) => {
            if (value instanceof File) {
              formData.append(key, value);
            } else {
              formData.append(key, value);
            }
          });

        SettingsService.saveCompanySettings(formData)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.snackbar = true;
              this.succesMsg = response.data.message;
              this.getCompanySettings();
            }
          })
          .catch((error) => {
            this.loading = false;
            this.errors = checkError.errorFormatting(error.response.data);
          });
      }
    },
    getCountries() {
      this.loading = true;
      CustomerService.getCountries()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.countries = response.data.map((obj) => obj.name);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getStates() {
      this.loading = true;
      CustomerService.getStates(this.form.company_country)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.states = response.data.map((obj) => obj.name);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
